import type React from "react";
import { FluentProvider, createDarkTheme, createLightTheme } from "@fluentui/react-components";
import type { BrandVariants } from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { darkModeAtom, isRTLAtom } from "../store";

const cbcBrandRamp: BrandVariants = {
  10: "#050202",
  20: "#231211",
  30: "#3C1B1A",
  40: "#502221",
  50: "#662928",
  60: "#7C2F30",
  70: "#933638",
  80: "#AA3D3F",
  90: "#B74F4E",
  100: "#C0625F",
  110: "#CA7470",
  120: "#D28682",
  130: "#DA9894",
  140: "#E2ABA6",
  150: "#EABDB9",
  160: "#F0CFCC",
};

const lightTheme = createLightTheme(cbcBrandRamp);
const darkTheme = createDarkTheme(cbcBrandRamp);

export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const darkMode = useAtomValue(darkModeAtom);
  const isRTL = useAtomValue(isRTLAtom);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <FluentProvider theme={theme} dir={isRTL ? "rtl" : "ltr"}>
      {children}
    </FluentProvider>
  );
};
